import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { usePageTracking } from './hooks/usePageTracking';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Blog from './pages/Blog';
import Certifications from './pages/Certifications';
import Services from './pages/Services';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import About from './pages/About';
import Dallas from './pages/locations/Dallas';
import Carrollton from './pages/locations/Carrollton';
import DFW from './pages/locations/DFW';

// Fires a GA4 page_view on each route change. Must live inside <Router> so it
// can read the current location.
function RouteTracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <Router>
      <RouteTracker />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/locations/dallas" element={<Dallas />} />
          <Route path="/locations/carrollton" element={<Carrollton />} />
          <Route path="/locations/dfw" element={<DFW />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
